import { Http } from './http.init'
import { ResponseWrapper, ErrorWrapper } from './util'
import $store from '~/store'
import $router from '~/router'
import { ENDPOINT } from '~/api/endpoint'
import { COOKIE_TOKEN_EXPIRE } from '~/utils/constants'
import cookies from '~/utils/cookie'

export class AuthService {
  /**
   ******************************
   * @API
   ******************************
   */

  static async makeLogin({ phone, password }) {
    console.log("🚀 ~ file: auth.service.js:17 ~ AuthService ~ makeLogin ~ makeLogin")
    try {
      let requestData = {
        data: {
          phone,
          password
        }
      }
      const response = await new Http({ auth: false }).post(
        `${process.env.VUE_APP_API_URL}${ENDPOINT.API_LOGIN}`,
        requestData,
        { withCredentials: false }
      )
      _setAuthData({
        accessToken: response.data.token,
        exp: _parseTokenData(response.data.token).exp
      })
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async makeLogout() {
    try {
      const response = await new Http({ auth: true }).post(
        'user/logout',
        {},
        { withCredentials: false }
      )
      _resetAuthData()
      $router.push({ name: 'Login' }).catch(() => {})
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  /**
   ******************************
   * @METHODS
   ******************************
   */
  static debounceRefreshTokens() {
    const token = cookies.get('token')
    return Promise.resolve({
      data: {
        accessToken: token
      }
    })
  }

  static isAccessTokenExpired() {
    const accessTokenExpDate = $store.state.auth.accessTokenExpDate - 10
    const nowTime = Math.floor(new Date().getTime() / 1000)

    return accessTokenExpDate <= nowTime
  }

  static hasRefreshToken() {
    return Boolean(localStorage.getItem('refreshToken'))
  }

  static setRefreshToken(status) {
    if (!['', 'true'].includes(status)) {
      throw new Error(
        `setRefreshToken: invalid value ${status}; Expect one of ['', 'true']`
      )
    }

    localStorage.setItem('refreshToken', status)
  }

  static getBearer() {
    const token = cookies.get('token')
    return `Bearer ${token}`
  }

  static setBearer(accessToken) {
    const expires = (new Date(Date.now() + COOKIE_TOKEN_EXPIRE))
    const cookieOption = { 
      path: '/',
      expires
    }
    cookies.set('token', accessToken, cookieOption)
  }

  static resetAuthData() {
    _resetAuthData()
  }
}

/**
 ******************************
 * @private_methods
 ******************************
 */

// eslint-disable-next-line no-unused-vars
function _parseTokenData(accessToken) {
  let payload = ''
  let tokenData = {}

  try {
    payload = accessToken.split('.')[1]
    tokenData = JSON.parse(atob(payload))
  } catch (error) {
    throw new Error(error)
  }

  return tokenData
}

function _resetAuthData() {
  // reset userData in store
  $store.commit('user/SET_CURRENT_USER', {})
  $store.commit('auth/SET_ATOKEN_EXP_DATE', null)
  // reset tokens
  AuthService.setRefreshToken('')
  AuthService.setBearer('')
  cookies.remove('token')
}

// eslint-disable-next-line no-unused-vars
function _setAuthData({ accessToken, exp } = {}) {
  AuthService.setRefreshToken('true')
  AuthService.setBearer(accessToken)
  $store.commit('auth/SET_ATOKEN_EXP_DATE', exp)
}
